import * as stylex from "@stylexjs/stylex";
import { colors, spacing } from "@softmax/design-system/tokens.stylex";
import { type ReactNode } from "react";

export function StorefrontHero({
  header,
  lead,
  cta,
  requirements,
  editor,
  media,
  mediaStripHeight = 0,
}: {
  readonly header: ReactNode;
  readonly lead: ReactNode;
  readonly cta: ReactNode;
  readonly requirements: ReactNode;
  readonly editor?: ReactNode;
  readonly media: ReactNode;
  readonly mediaStripHeight?: number;
}) {
  return (
    <section {...stylex.props(styles.root)}>
      <div {...stylex.props(styles.lane)}>
        {header}
        <div {...stylex.props(styles.grid)}>
          <div
            {...stylex.props(styles.copy, styles.stripSpace(mediaStripHeight))}
          >
            {lead}
            <div data-store-play {...stylex.props(styles.door)}>
              {cta}
              {requirements}
            </div>
            {editor}
          </div>
          <div {...stylex.props(styles.media)}>{media}</div>
        </div>
      </div>
    </section>
  );
}

const styles = stylex.create({
  root: {
    containerType: "inline-size",
    width: "100%",
    backgroundColor: colors.background,
  },
  lane: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 1200,
    marginInline: "auto",
    paddingBlock: spacing.space32,
    paddingInline: {
      default: spacing.space32,
      "@media (min-width: 1024px)": {
        default: spacing.space64,
        ":is([data-rail] *)": spacing.space32,
      },
    },
  },
  grid: {
    display: "grid",
    gap: spacing.space32,
    gridTemplateColumns: {
      default: "minmax(0, 1fr)",
      "@container (min-width: 880px)": "minmax(0, 1fr) minmax(0, 2fr)",
    },
    columnGap: {
      default: spacing.space32,
      "@container (min-width: 880px)": spacing.space40,
    },
  },
  copy: {
    display: "flex",
    minWidth: 0,
    flexDirection: "column",
    alignItems: "flex-start",
    gap: {
      default: spacing.space20,
      "@container (min-width: 880px)": spacing.space28,
    },
    justifyContent: {
      default: "flex-start",
      "@container (min-width: 880px)": "center",
    },
  },
  stripSpace: (height: number) => ({
    paddingBottom: { default: 0, "@container (min-width: 880px)": height },
  }),
  door: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: spacing.space8,
  },
  media: {
    minWidth: 0,
    alignSelf: { default: "stretch", "@container (min-width: 880px)": "start" },
  },
});
